import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import './MultiPanel.sass';
import { MultiPanelItem } from './MultiPanelItem';
import { SIZE } from '../../constants';
export { SIZE };
export class MultiPanel extends React.PureComponent {
    stack = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    currentFocusedElementRef = React.createRef();
    state = {
        panels: this.initPanels(this.props.panels),
        isClosed: this.props.isClosed,
        isMounted: false, // aby zafungovalo prerenderovani v ramci componentDidMount
    };
    // eslint-disable-next-line react/no-deprecated
    UNSAFE_componentWillReceiveProps(nextProps) {
        const newState = this.processPanel(nextProps.shownPanelId);
        this.setState({
            ...newState,
            isClosed: nextProps.isClosed,
        });
        this.props.onLevelChange?.({
            level: this.stack.length,
        });
    }
    componentDidMount() {
        const newState = this.processPanel(this.props.shownPanelId);
        newState && this.setState(newState);
    }
    initPanels(panelsArray) {
        return panelsArray.map((panel) => {
            return {
                ...panel,
                size: panel.size ?? SIZE.MED,
                level: 0,
            };
        });
    }
    processPanel(newPanelId) {
        let newState = null;
        // Optimalizace aby se neoteviral panel, ktery je prave otevreny
        if (this.stack.length === 0 || this.stack[this.stack.length - 1].id !== newPanelId) {
            const newPanel = newPanelId
                ? this.state.panels?.find((panel) => panel.id === newPanelId)
                : undefined;
            if (newPanel &&
                (this.stack.length === 0 || this.stack[this.stack.length - 1].priority < newPanel.priority)) {
                this.stack.push(newPanel);
                newPanel.level = this.stack.length;
                newState = {
                    isMounted: true,
                };
            }
            else if (this.stack.length > 0) {
                const topPanel = this.stack.pop();
                if (topPanel) {
                    topPanel.level = 0;
                }
                return this.processPanel(newPanelId);
            }
        }
        return newState;
    }
    // For TDD reason
    getOpenPanelState(level) {
        do {
            const topPanel = this.stack.pop();
            if (topPanel) {
                topPanel.level = 0;
            }
        } while (this.stack.length > level);
        return {
            isClosed: false,
        };
    }
    handleOpenBtnClick = (e, eventData) => {
        if (this.state.isClosed) {
            this.setState({
                isClosed: false,
            });
            this.props.onOpen?.(e);
        }
        else {
            this.setState(this.getOpenPanelState(eventData.data));
            this.props.onChange?.(e, {
                panelId: this.stack[this.stack.length - 1].id,
            });
        }
    };
    // TDD reason
    getHideTopPanelState() {
        const topPanel = this.stack.pop();
        if (topPanel) {
            topPanel.level = 0;
        }
    }
    hideTopPanel = (e) => {
        this.getHideTopPanelState();
        this.props.onChange?.(e, {
            panelId: this.stack.length > 0 ? this.stack[this.stack.length - 1].id : '',
        });
    };
    handleTransitionEnd = () => {
        if (!this.state.isClosed) {
            this.currentFocusedElementRef.current?.focus();
        }
    };
    closePanel = () => {
        this.setState({
            isClosed: true,
        });
    };
    render() {
        let className = this.props.side === 'left' ? ' sg-multiPanel-left' : '';
        className += this.props.side === 'right' ? ' sg-multiPanel-right' : '';
        className += this.state.isClosed ? ' sg-multiPanel-isClosed' : '';
        return (_jsx("div", { className: 'sg-multiPanel' + className, "data-size": (this.stack.length > 0 && this.stack[this.stack.length - 1].size) || undefined, children: this.state.panels?.map((panel, index) => (_jsx(MultiPanelItem, { level: panel.level > 0 ? this.stack.length - panel.level + 1 : 0, priority: panel.priority, size: panel.size, isClosed: this.state.isClosed, onTransitionEnd: panel.isFocusable && panel.level > 0 && this.stack.length === panel.level
                    ? this.handleTransitionEnd
                    : undefined, data: panel.level, onOpenBtnClick: this.handleOpenBtnClick, testId: this.props.testId ? `${this.props.testId}-item-${index + 1}` : undefined, children: _jsx(panel.content, { id: panel.id, focusedElementRef: panel.isFocusable && this.stack.length === panel.level
                        ? this.currentFocusedElementRef
                        : undefined, hidePanel: this.hideTopPanel, closePanel: this.closePanel }) }, panel.id))) }));
    }
}
//# sourceMappingURL=MultiPanel.js.map